import * as api from 'common/api'

// 班级列表
export let list = params => {
  let url = params.user_uid ? 'account/teacher/group/list' : 'account/school/group/list'
  return api.get(url, params)
}
// 编辑班级
export let edit = params => api.post('account/school/group/edit', params)
// 查看班级
export let get = params => api.get('account/school/group/edit', params)



// WEBPACK FOOTER //
// ./src/api/group.js